module.exports = __webpack_public_path__ + "assets/emoticon-1star.9a858588.svg";